<mat-card class="flex flex-col">
  <mat-card-title class="!flex flex-row justify-between items-center">
    {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.TITLE' | translate }}
    <button
      mat-icon-button
      mat-dialog-close
      gtm="onClose"
      gtmAction="Active errors popup"
      gtmCategory="gatewaySearch"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content>
    <div
      *ngFor="let error of data.errors"
      class="active-error__item flex flex-row gap-[16px] justify-between items-start"
    >
      <div class="identifier">
        <mat-icon class="identifier__icon">computer</mat-icon>
      </div>
      <div class="active-error__content flex flex-row lt-md:flex-col justify-between items-start">
        <div>
          <p class="active-error__title">{{ error.content.errorCode }}</p>
          <p>{{ error.content.errorDescription }}</p>
        </div>
        <small>{{ error.content.appearedAt | date: 'short' }}</small>
      </div>
    </div>
  </mat-card-content>
</mat-card>
